// 위클라인 처치 알림과 위클 버프 계산 (순수 함수).

export const WICKELINE_BUFF_SEC = 210; // 위클 버프 지속 시간 3분 30초 (사용자 제공)
const REARM_AFTER_MS = 8000; // 배너가 마지막으로 보인 뒤 이만큼 지나야 새 처치로 본다

/**
 * 배너 감지 결과(보임/안 보임)를 받아 "처치가 새로 일어났다"를 한 번만 알려 주는 추적기.
 * 배너는 약 2~3초 떠 있어 1.5초 간격 확인으로 두 번 연속 보일 수 있으니, 마지막으로 보인 뒤 8초가 지나야 다시 알린다.
 */
export function createWickelineTracker() {
  let lastSeenAt = null;
  return {
    // matched: 이번 확인에서 배너가 보였는지. 새 처치면 true를 돌려준다.
    update(matched, nowMs) {
      if (!matched) {
        return false;
      }
      const isNew = lastSeenAt === null || nowMs - lastSeenAt > REARM_AFTER_MS;
      lastSeenAt = nowMs;
      return isNew;
    },
    reset() {
      lastSeenAt = null;
    },
  };
}

// 처치한 순간의 게임 시각(초) → 버프 종료 게임 시각(초). 게임 시각을 모르면 null.
export function buffEndGameSec(killGameSec) {
  return killGameSec === null || killGameSec === undefined ? null : killGameSec + WICKELINE_BUFF_SEC;
}

// 처치를 감지한 실제 시각과 지금의 실제 시각(밀리초)으로 버프가 남은 시간(초). 0~210 범위.
export function buffRemainingSec(killAtMs, nowMs) {
  const elapsed = Math.floor((nowMs - killAtMs) / 1000);
  return Math.min(WICKELINE_BUFF_SEC, Math.max(0, WICKELINE_BUFF_SEC - elapsed));
}

// 남은 초 → "MM:SS"
export function formatRemaining(sec) {
  return `${String(Math.floor(sec / 60)).padStart(2, '0')}:${String(sec % 60).padStart(2, '0')}`;
}
